// extracted by mini-css-extract-plugin
export default {"container":"About_container__AqPOV","image":"About_image__yEayv","heading":"About_heading__QQ4da","text":"About_text__C7Bdz","list":"About_list__wzItc"};